import Pagination from './components/pagination';
import Dialog from './components/dialog';
import Autocomplete from './components/autocomplete';
import Dropdown from './components/dropdown';
import DropdownMenu from './components/dropdown-menu';
import DropdownItem from './components/dropdown-item';
import MenuBar from './components/menu/src/menuBar';
import Menu from './components/menu';
import Submenu from './components/submenu';
import MenuItem from './components/menu-item';
import MenuItemGroup from './components/menu-item-group';
import Input from './components/input';
import InputNumber from './components/input-number';
import Radio from './components/radio';
import RadioGroup from './components/radio-group';
import RadioButton from './components/radio-button';
import Checkbox from './components/checkbox';
import CheckboxButton from './components/checkbox-button';
import CheckboxGroup from './components/checkbox-group';
import Switch from './components/switch';
import Select from './components/select';
import Option from './components/option';
import OptionGroup from './components/option-group';
import Button from './components/button';
import ButtonGroup from './components/button-group';
import Table from './components/table';
import TableColumn from './components/table-column';
import DatePicker from './components/date-picker';
import TimeSelect from './components/time-select';
import TimePicker from './components/time-picker';
import Popover from './components/popover';
import Tooltip from './components/tooltip';
import MessageBox from './components/message-box';
import Breadcrumb from './components/breadcrumb';
import BreadcrumbItem from './components/breadcrumb-item';
import Form from './components/form';
import FormItem from './components/form-item';
import Tabs from './components/tabs';
import TabPane from './components/tab-pane';
import Tag from './components/tag';
import Tree from './components/tree';
import Alert from './components/alert';
import Notification from './components/notification';
import Slider from './components/slider';
import Loading from './components/loading';
import Icon from './components/icon';
import Row from './components/row';
import Col from './components/col';
import Upload from './components/upload';
import Progress from './components/progress';
import Message from './components/message';
import Badge from './components/badge';
import Card from './components/card';
import Rate from './components/rate';
import Steps from './components/steps';
import Step from './components/step';
import Carousel from './components/carousel';
import Scrollbar from './components/scrollbar';
import CarouselItem from './components/carousel-item';
import Collapse from './components/collapse';
import CollapseItem from './components/collapse-item';
import Cascader from './components/cascader';
import ColorPicker from './components/color-picker';
import Transfer from './components/transfer';
import Container from './components/container';
import Main from './components/main';
import Footer from './components/footer';
import Timeline from './components/timeline';
import TimelineItem from './components/timeline-item';
import Link from './components/link';
import Divider from './components/divider';
import Image from './components/image';
// import Calendar from './components/calendar';
import Backtop from './components/backtop';
import InfiniteScroll from './components/infinite-scroll';
import PageHeader from './components/page-header';
import CascaderPanel from './components/cascader-panel';
import Avatar from './components/avatar';
import Drawer from './components/drawer';
import Popconfirm from './components/popconfirm';
import Money from './components/money';
import Percentage from './components/percentage';
import Password from './components/password';
import Label from './components/label';
import JsonViewer from './components/viewer/JsonViewer.vue';
import Chart from './components/chart';
import Toolbar from './components/toolbar';
import Panel from './components/panel';


export default {
  version: '1.0.0',
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MenuBar,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  MessageBox,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Notification,
  Slider,
  Loading,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Message,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Carousel,
  Scrollbar,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  ColorPicker,
  Transfer,
  Container,
  Main,
  Footer,
  Timeline,
  TimelineItem,
  Link,
  Divider,
  Image,
  // Calendar,
  Backtop,
  InfiniteScroll,
  PageHeader,
  CascaderPanel,
  Avatar,
  Drawer,
  Popconfirm,
  Money,
  Percentage,
  Password,
  Label,
  JsonViewer,
  Chart,
  Toolbar,
  Panel
};